import SupportersForm from "../../../../src/events/2022/05/supporters/form/index.js";
import * as React from 'react';
export default {
  SupportersForm,
  React
};